import { render, staticRenderFns } from "./ManageTrainNav.vue?vue&type=template&id=50c8ade2"
import script from "./ManageTrainNav.vue?vue&type=script&lang=js"
export * from "./ManageTrainNav.vue?vue&type=script&lang=js"
import style0 from "./ManageTrainNav.vue?vue&type=style&index=0&id=50c8ade2&prod&lang=stylus"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports